import firebase from 'firebase';

const firebaseConfig = {

  apiKey: "AIzaSyDO8towvGkXIpxTOJWbJmjldA0Ljn_Quv8",

  authDomain: "swasthmindfreespace-34d09.firebaseapp.com",

  projectId: "swasthmindfreespace-34d09",

  storageBucket: "swasthmindfreespace-34d09.appspot.com",

  messagingSenderId: "420927967825",

  appId: "1:420927967825:web:f7b97f44152b8a36c51e70",

  measurementId: "G-JXK41PTC5R"

};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

const auth = firebaseApp.auth();

export { db, auth };